import * as logger from 'loglevel'

export default class CssLoader {
  /**
   * Returns the existing <link> (if any) and its ID for a given event’s CSS
   */
  static getAppStyleElement(anearEvent) {
    const appStyleId = `style-${anearEvent.zone.app.id}`
    return {
      appStyle: document.getElementById(appStyleId),
      appStyleId,
    }
  }

  /**
   * Removes the <link> for anearEvent.cssUrl if one already exists
   */
  static removeAppCss(anearEvent) {
    const { appStyle, appStyleId } = this.getAppStyleElement(anearEvent)
    if (appStyle) {
      logger.info(`removing existing style with id=${appStyleId}`)
      appStyle.parentNode.removeChild(appStyle)
    }
  }

  /**
   * Ensures there's a <link id="style-<appId>"> pointing at anearEvent.cssUrl;
   * updates href if it's changed
   */
  static ensureAppCss(anearEvent) {
    const { appStyle, appStyleId } = this.getAppStyleElement(anearEvent)
    if (!appStyle) {
      const link = document.createElement('link')
      link.id   = appStyleId
      link.rel  = 'stylesheet'
      link.href = anearEvent.cssUrl
      document.head.appendChild(link)
      logger.info(`set CSS styles for styleId ${appStyleId}`)
    } else if (appStyle.href !== anearEvent.cssUrl) {
      appStyle.href = anearEvent.cssUrl
      logger.info(`CSS updated for styleId ${appStyleId} with new href: ${anearEvent.cssUrl}`)
    } else {
      logger.info(`CSS for styleId ${appStyleId} is already up to date.`)
    }
  }

  /**
   * Injects CSS into a shadow root for child apps
   * Creates a <link> element inside the shadow root pointing to anearEvent.cssUrl
   */
  static ensureAppCssInShadow(anearEvent, shadowRoot) {
    if (!shadowRoot) {
      logger.warn('ensureAppCssInShadow: shadowRoot is required')
      return
    }

    const appStyleId = `style-${anearEvent.zone.app.id}`
    let appStyle = shadowRoot.getElementById?.(appStyleId)

    // If getElementById is not available, query manually
    if (!appStyle) {
      appStyle = shadowRoot.querySelector(`#${appStyleId}`)
    }

    if (!appStyle) {
      const link = document.createElement('link')
      link.id = appStyleId
      link.rel = 'stylesheet'
      link.href = anearEvent.cssUrl
      shadowRoot.appendChild(link)
      logger.info(`set CSS styles in shadow DOM for styleId ${appStyleId}`)
    } else if (appStyle.href !== anearEvent.cssUrl) {
      appStyle.href = anearEvent.cssUrl
      logger.info(`CSS updated in shadow DOM for styleId ${appStyleId} with new href: ${anearEvent.cssUrl}`)
    } else {
      logger.info(`CSS in shadow DOM for styleId ${appStyleId} is already up to date.`)
    }
  }
}
